import React from 'react';
import LayoutDefinition from './LayoutDefinition';

export default function CreateReport({
  isActive,
  setIsActive,
  layoutName,
  setLayoutName,
  saveLayout,
  saving = false,
  error = '',
  shared = false,
  setShared,
  ownerName = '',
  fieldOptions,
  editing = false,
  fields = [],
  onFieldsChange,
}) {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Define Layout</h2>
      <div className="p-6">
        {/* Header Controls */}
        <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
          <div className="flex items-center gap-4 mb-4">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={isActive}
                onChange={() => setIsActive(!isActive)}
                className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
              />
              <span className="font-medium text-gray-700 dark:text-gray-300">Active</span>
            </label>
            <div className="flex items-center gap-2">
              <label htmlFor="layout-name" className="font-medium text-gray-700 dark:text-gray-300">Name</label>
              <input
                id="layout-name"
                type="text"
                value={layoutName}
                onChange={(e) => setLayoutName(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                style={{ width: 200 }}
              />
            </div>
            <button
              onClick={saveLayout}
              disabled={saving}
              className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 disabled:cursor-wait text-white font-medium rounded-md transition-colors duration-200"
            >
              {saving ? "Saving..." : editing ? "Save and Overwrite" : "Save New"}
            </button>
          </div>
          <div className="flex flex-wrap items-center gap-6">
            <div className="flex items-center gap-2">
              <label htmlFor="layout-visibility" className="font-medium text-gray-700 dark:text-gray-300">Visibility</label>
              <select
                id="layout-visibility"
                value={shared ? 'shared' : 'private'}
                onChange={(e) => setShared(e.target.value === 'shared')}
                className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="private">Private (only the owner)</option>
                <option value="shared">Shared (everyone can use it)</option>
              </select>
            </div>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Owner: {editing ? (ownerName || 'none (managed by admins)') : 'you'}
              {' '}· only the owner and admins can change or delete a layout.
            </span>
          </div>
          {error && (
            <div role="alert" className="mt-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800 dark:border-red-900 dark:bg-red-950/40 dark:text-red-200">
              {error}
            </div>
          )}
        </div>

        {/* Layout Definition with Transfer List */}
        <div className="mb-6">
          <LayoutDefinition
            items={fieldOptions}
            selectedItems={fields}
            onFieldListChange={(selectedFields) => onFieldsChange?.(selectedFields)}
          />
        </div>
      </div>
    </div>
  );
}